// 组件页面在加载的时候显示 由其是首次加载
import './Loading.css';
import loadingImage from '../../../src/assets/robot.png';

function Loading() {
    return (
        <div className='Loading root'>
            <img src={loadingImage} alt="Loading" />
        </div>
    );
}

export default Loading;